import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import c from "../../helpers/constants";
import { NavLink } from "react-router-dom";
import CONSTANTS from "../../helpers/constants";
import LWModal from "../Modal/Modal";
import "./AccountNav.scss";

import {
  getCustomerID,
  setCustomerBranch,
  setCustomerID,
  setCustomerPostcode,
  setCustomerStatus,
} from "../../helpers/functions";
import history from "../../helpers/history";
import ChangePassword from "../ChangePassword";
import { clearBasketRequest } from "../../actions/Order";
import { config } from "../../config/config";
import Button from "../Button";
import { getCustomer, isFetchingCustomer } from "../../selectors/Customer";
import { fetchCustomer } from "../../actions/Customer";
import Alert from "../Alert";

const AccountNav = () => {
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const customer = useSelector(getCustomer);
  const isLoadingCustomer = useSelector(isFetchingCustomer);
  const lastHideDetailsRef = useRef<boolean>(true);

  const [passwordUpdated, setPasswordUpdated] = useState(false);
  const [passwordUpdatedFailed, setPasswordUpdatedFailed] = useState(false);

  const enablePricelists =
    config.hasOwnProperty("enablePricelists") && config.enablePricelists;

  // Use last known value if customer is null (during refetch), otherwise use current value
  const hideDetails = customer 
    ? (lastHideDetailsRef.current = customer.hidedetails === true)
    : lastHideDetailsRef.current;
  const showPrices = customer ? customer.showprices === true : false;
  const validcustomer = customer ? config.enabledPayit.indexOf(customer.brn || '') > -1 :  false;
  const showBasket = customer ? customer.showbasket === true : false;

  const onLogout = () => {
    clearBasketRequest();
    setCustomerID("");
    setCustomerBranch("");
    setCustomerStatus("");

    setCustomerPostcode("");
    window.location.href = window.location.href; //
  };

  const managePasswordChangeOption = () => {
    if (config.popupPasswordReset == true) {
      setToggle(true);
      return;
    }
    history.push({ pathname: c.APP_ROUTES.PASSWORD_CHANGE });
  };

  return (
    <div className="account-nav-outer">
      <ul>
        {!hideDetails && (
        <NavLink
          exact={true}
          to={CONSTANTS.APP_ROUTES.ACCOUNT}
          className="menu-link"
          activeClassName="active"
        >
          <li className="pb-4">Account Information</li>
        </NavLink>
        )}

    { !hideDetails && (
          <NavLink
            exact={true}
            to={CONSTANTS.APP_ROUTES.ORDERS}
            className="menu-link"
            activeClassName="active"
          >
            <li className="pb-4">My Orders</li>
          </NavLink>
        )}

        {!hideDetails && enablePricelists && customer && !customer?.is_matting && showPrices && (
          <NavLink
            exact={true}
            to={CONSTANTS.APP_ROUTES.PRICELIST}
            className="menu-link"
            activeClassName="active"
          >
            <li className="pb-4">My Pricelist</li>
          </NavLink>
        )}

        {!hideDetails && showPrices  &&
          <NavLink
            exact={true}
            to={CONSTANTS.APP_ROUTES.ACCOUNT_SUMMARY}
            className="menu-link"
            activeClassName="active"
          >
            <li className="pb-4">Account Summary</li>
          </NavLink>
        }

        {!hideDetails && config.enablePayments == true && showPrices && validcustomer && (
          <NavLink
            exact={true}
            to={CONSTANTS.APP_ROUTES.MY_STATEMENTS}
            className="menu-link"
            activeClassName="active"
          >
            <li className="pb-4">Account Statement</li>
          </NavLink>
        )}

        {!hideDetails && <NavLink
          exact={true}
          to={CONSTANTS.APP_ROUTES.UPDATE_ACCOUNT_INFO}
          className="menu-link"
          activeClassName="active"
        >
          <li className="pb-4">Update Account Info</li>
        </NavLink>
        }
        <a
          onClick={() => managePasswordChangeOption()}
          className={
            CONSTANTS.APP_ROUTES.PASSWORD_CHANGE == window.location.pathname
              ? "active menu-link"
              : "menu-link"
          }
        >
          <li className="pb-4">Change Password</li>
        </a>
      </ul>
      <ul>
        {!hideDetails && (
        <li>
          <NavLink
            exact={true}
            to={CONSTANTS.APP_ROUTES.DELETE_ACCOUNT}
            className="menu-link delete-account-link"
            activeClassName="active"
          >
            Delete Account
          </NavLink>
        </li>
        )}
        {config.myAccount.showLogin && (
          <li className="pt-2">
            <Button text="Logout" type="grey" onClick={onLogout} />
          </li>
        )}
      </ul>
      <LWModal
        title="Change Password"
        onClose={() => {
          setToggle(false);
          setEmailSent(false);
        }}
        show={toggle}
      >
        <ChangePassword
          useToken={true}
          showAllCustomerDetails={false}
          setPasswordUpdated={() => {
            setToggle(false);
            setTimeout(() => {
              setPasswordUpdated(true);
            }, 500);
          }}
          setPasswordUpdatedFailed={() => {
            setToggle(false);
            setTimeout(() => {
              setPasswordUpdatedFailed(true);
            }, 500);
          }}
        ></ChangePassword>
      </LWModal>

      {passwordUpdated && (
        <Alert
          title="Password Updated"
          message="Your password has been updated successfully"
          showOkButton={true}
          showCancelButton={false}
          onOk={() => {
            setPasswordUpdated(false);
          }}
        />
      )}

      {passwordUpdatedFailed && (
        <Alert
          title="Password Update Failed"
          message="There was an error updating your password, please try again"
          showOkButton={true}
          showCancelButton={false}
          onOk={() => {
            setPasswordUpdatedFailed(false);
          }}
        />
      )}
    </div>
  );
};

export default AccountNav;
